import React, { Component } from "react";

import { PasswordInputStrings } from "./PasswordInput.strings";
import "./PasswordInput.component.scss";

export interface PasswordInputState {
    passwordShowing: boolean;
}

export interface PasswordInputProps {
    field?: any;
    form?: any;
}

export default class PasswordInput extends Component<
    PasswordInputProps,
    PasswordInputState
> {
    constructor(props) {
        super(props);

        this.state = {
            passwordShowing: false
        };
    }

    onVisibilityToggle = () => {
        this.setState({
            passwordShowing: !this.state.passwordShowing
        });
    };

    render() {
        const inputType = this.state.passwordShowing ? "text" : "password";
        const icon = this.state.passwordShowing
            ? "icon-eye-slash-light"
            : "icon-eye-light";

        const errorMessage = this.props.form.errors[this.props.field.name] &&
            this.props.form.errors[this.props.field.name].startsWith(
                "MIN_LENGTH"
            ) && (
                <div className="input-error">
                    <span className="input-error-message">
                        {`Password must be larger than ${
                            this.props.form.errors[this.props.field.name].match(
                                /{(.*?)}/
                            )[1]
                        } characters`}
                    </span>
                </div>
            );

        return (
            <div id="PasswordInput">
                <input
                    type={inputType}
                    className="input"
                    placeholder={PasswordInputStrings.PASSWORD}
                    spellCheck={false}
                    {...this.props.field}
                    {...this.props}
                />
                <div className="password-icon">
                    <i className={icon} onClick={this.onVisibilityToggle}></i>
                </div>
                {errorMessage}
            </div>
        );
    }
}
